module.exports = __webpack_public_path__ + "img/packages/tablet.5b5610.png";